<template>
  <div>
    <b-button
      v-if="!hideTrigger"
      variant="outline-primary"
      class="ml-2"
      :disabled="isLoading"
      @click="showModalImport = true"
    >
      <i class="ri-upload-2-line pl-1"></i>
      Import
    </b-button>

    <b-modal
      v-model="showModalImport"
      title="Import Data"
      ok-title="Submit"
      :ok-disabled="isLoading"
      @ok="handleImport"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i class="fa fa-times cursor-pointer" @click="showModalImport = false"></i>
      </template>
      <template>
        <div v-if="vehicleName" class="alert alert-light border mb-3 py-2 px-3">
          <strong>Vessel:</strong> {{ vehicleName }}
        </div>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
            :disabled="isLoading"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          variant="outline-primary"
          class="mt-3 w-100"
          :disabled="isLoading"
          @click="handleDownloadTemplate"
        >
          <i class="fa fa-download"></i>
          Download Template Import PMS
          <b-spinner small v-if="isLoading" class="ml-2"></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="modalResponseImport"
      title="Import Result"
      size="xl"
      hide-footer
      @close="refetch"
    >
      <ImportResultRh
        :response="dataResponseImport"
        :errorFields="errorFieldImport"
        :successFields="successFieldImport"
      />
    </b-modal>

    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-container">
        <b-spinner type="grow" variant="primary" label="Loading..."></b-spinner>
        <p class="mt-2">Processing...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { pmsActions } from '@/src/Utils/helper'
import ImportResultRh from '@/src/views/Maintenance/RunningHourNew/ImportResultRh.vue'
import { saveAs } from 'file-saver'

export default {
  name: 'ImportPmsProcessMultipleModal',
  components: {
    ImportResultRh
  },
  props: {
    refetch: {
      type: Function,
      required: false
    },
    hideTrigger: {
      type: Boolean,
      default: false
    },
    vehicleId: {
      type: [String, Number],
      default: null
    },
    vehicleName: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.showModalImport = true
      }
    },
    showModalImport (val) {
      if (!val) {
        this.$emit('update:isOpen', false)
      }
    }
  },
  data () {
    return {
      showModalImport: false,
      importFile: null,
      isLoading: false,
      modalResponseImport: false,
      dataResponseImport: null,
      successFieldImport: [
        { key: 'row', label: 'Row' },
        // { key: 'fleet_name', label: 'Fleet Name' },
        // { key: 'job_name', label: 'Job Name' },
        { key: 'status', label: 'Status' }
      ],
      errorFieldImport: [
        { key: 'row', label: 'Row' },
        { key: 'errors', label: 'Error Messages' }
      ]
    }
  },
  methods: {
    ...pmsActions,
    async handleImport () {
      if (!this.importFile) {
        this.$swal({
          title: 'File belum dipilih',
          text: 'Silakan pilih file import terlebih dahulu.',
          icon: 'warning'
        })
        return
      }

      try {
        this.isLoading = true
        const formData = new FormData()
        formData.append('file', this.importFile)
        if (this.vehicleId) {
          formData.append('vehicle_id', this.vehicleId)
        }
        const res = await this.importPmsProcessMultiple(formData)
        this.dataResponseImport = res.data?.data
        this.modalResponseImport = true
        this.refetch && this.refetch()
    } catch (error) {
        this.$swal({
          title: 'Failed Import Data!',
          text: 'Failed Import Data please check your file import!',
          icon: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },
    async handleDownloadTemplate () {
      try {
        this.isLoading = true
        const params = this.vehicleId ? { vehicle_id: this.vehicleId } : {}
        const res = await this.exportTemplatePmsProcessMultiple(params)
        const vehicleSlug = this.vehicleName
          ? this.vehicleName
              .toLowerCase()
              .trim()
              .replace(/[^a-z0-9]+/g, '_')
              .replace(/^_+|_+$/g, '')
          : ''
        const fileName = vehicleSlug
          ? `import_template_pms_process_multiple_${vehicleSlug}.xlsx`
          : 'import_template_pms_process_multiple.xlsx'

        saveAs(res.data, fileName)
        this.$swal({
          title: 'Download Template Success',
          text: 'Template berhasil diunduh.',
          icon: 'success'
        })
      } catch (error) {
        this.$swal({
          title: 'Failed Export Template',
          icon: 'error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.spinner-container {
  background-color: white;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.spinner-container p {
  color: #666;
  font-weight: 500;
  margin: 0;
}
</style>
